import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useIntl } from 'react-intl';
import classNames from 'classnames';
import messages from './messages';
const titleFor = (state) => {
    switch (state) {
        case 1:
            return messages.AutosendOffCompany;
        case 2:
            return messages.AutosendOffRelation;
        case 3:
            return messages.AutosendOffStream;
        default:
            return messages.AutosendOn;
    }
};
const AutosendIcon = ({ state, hasBillingError = false, }) => {
    const intl = useIntl();
    if (hasBillingError) {
        return (_jsx("i", { className: "fa fa-exclamation-circle autosend-icon autosend-error", title: intl.formatMessage(messages.BillingError) }));
    }
    return (_jsx("i", { className: classNames('fa autosend-icon', {
            'fa-refresh autosend-on': state === 0,
            'fa-pause-circle autosend-off': state !== 0,
        }), title: intl.formatMessage(titleFor(state)) }));
};
AutosendIcon.defaultProps = { hasBillingError: false };
export default AutosendIcon;
